import { useSyncExternalStore } from "react";
import Link from "next/link";

const CONSENT_KEY = "cookie_consent_given";

// Dismissed in-memory for the session when storage can't persist (e.g. blocked).
let sessionDismissed = false;

function subscribe(callback) {
  window.addEventListener("storage", callback);
  return () => window.removeEventListener("storage", callback);
}

function getSnapshot() {
  if (sessionDismissed) {
    return true;
  }
  try {
    return localStorage.getItem(CONSENT_KEY) === "true";
  } catch {
    return true;
  }
}

// Hide during SSR/hydration; the real value is applied after hydration.
function getServerSnapshot() {
  return true;
}

export default function CookieBanner() {
  const dismissed = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  );

  const handleAccept = () => {
    sessionDismissed = true;
    try {
      localStorage.setItem(CONSENT_KEY, "true");
    } catch {
      // Persist unavailable (storage blocked); dismissed for this session only.
    }
    window.dispatchEvent(new Event("storage"));
  };

  if (dismissed) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <p>
        We use cookies to enhance your experience. By continuing to visit this
        site you agree to our use of cookies.{" "}
        <Link
          href="/privacy-policy"
          style={{ textDecoration: "underline", fontWeight: "bold" }}
        >
          Learn more
        </Link>
      </p>
      <button onClick={handleAccept}>Accept</button>
    </div>
  );
}
